import { render } from "./AttachmentsPreviews.vue?vue&type=template&id=0a587ab6&scoped=true"
import script from "./AttachmentsPreviews.vue?vue&type=script&lang=js"
export * from "./AttachmentsPreviews.vue?vue&type=script&lang=js"

import "./AttachmentsPreviews.vue?vue&type=style&index=0&id=0a587ab6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a587ab6"]])

export default __exports__